import styled from "styled-components";

export default styled.div`
  position: relative;
  display: flex;
  height: 50px;
  align-items: center;
  .date--location,
  .cta {
    display: flex;
    flex: 1 1 auto;
  }
  .cta {
    justify-content: flex-end;
    .action-buttons {
      display: flex;
      justify-content: flex-end;
      button {
        color: ${(props) => props.theme.colors.primary.main};
        width: 125px;

        &:disabled {
          color: rgba(0, 0, 0, 0.26);
        }
        .MuiButton-startIcon {
          margin-right: 15px;
        }
        margin-left: 10px;
      }
    }
  }

  .date--location {
    &.insider {
      display: flex;
      flex-direction: column;
    }
    div {
      display: flex;
    }
    div:first-child {
      margin-right: 10px;
    }
    .label,
    .value {
      font-size: 14px;
      letter-spacing: 0.24px;
      color: rgba(0, 0, 0, 0.6);
    }
    .label {
      font-weight: 600;
      margin-right: 10px;
    }
    .value {
      font-weight: 400;
    }
    .location {
      display: inline-block;
      width: 235px;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }
  }

  @media screen and (max-width: 991px) {
    height: unset;
    margin-bottom: 5px;
    .cta {
      justify-content: space-between;
      .action-buttons {
        justify-content: space-between;
        flex: 1 1 auto;
        button {
          flex: 1 1 auto;
          margin-left: unset;
          padding: 5px 0;
          width: 100%;
        }
      }
    }
  }

  @media screen and (min-width: 992px) and (max-width: 1024px) {
    .date--location {
      flex-direction: column;

      .fields {
        display: flex;

        .label {
          min-width: 100px;
        }
      }
    }
  }
`;
